<template>
<easy-data-table
	class="data-table m-0 p-0"
	table-class-name="customize-table"
	:headers="tableHeaders"
	:items="tableItems"
	:loading="tableItems.length == 0"
	theme-color="rgb(198, 199, 200)"
	must-sort="true"
	:sort-by="'unit'"
	:sort-type="'asc'" 
	:hide-footer="true"
	:table-min-height="380"
	:table-height="easyDataTableHeight(false)"
	:prevent-context-menu-row="false"
	:rows-per-page="tableItems.length"
	alternating
>
	<!-- If rows is empty -->
	<template #empty-message>
		Записів не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Name item customization -->
	<template #item-name="{ name }">
		<b class="fw-border">{{ name }}</b>
	</template>
</easy-data-table>
</template>




<script>
import { SECTOR_TITLE, DEPARTMENT_TITLE } from '@/app.conf'
import { useStationsStore } from '@/stores/StationsStore'
import {
	easyDataTableHeight,
	chartDateStr,
	dateTimeToTimeString,
} from '@/helpers.js'
import { FIELD_NAMES, parseApiTimeDate, } from '@/api/rest.js'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
import { ElectricMeter } from '@/models/electricMeter.js'
import { Breaker } from '@/models/breaker.js'


export default {
	components: {
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const stationsStore = useStationsStore()

		return {
			stationsStore,
			easyDataTableHeight,
		}
	},

	data() {
		return {
			// Table
			tableHeaders: [
				{ text: "Назва", value: "name", },
				{ text: "Модуль", value: "unit", sortable: true, },
				{ text: "Значення", value: "value" },
			],
		}
	},

	created() {},

	mouted() {},

	methods: {
		// settingName(settingId, unit) {
		// 	if (settingId == Station.passportKeys.departmentId) {
		// 		return this.accountStore.organization.department_title ? 
		// 			this.accountStore.organization.department_title :
		// 			Station.departmentDefaultTitle
		// 	} else if (settingId == Station.passportKeys.sectorId) {
		// 		return this.accountStore.organization.sector_title ? 
		// 			this.accountStore.organization.sector_title :
		// 			Station.sectorIdDefaultTitle
		// 	} else if (Station.settingNames[settingId]) {
		// 		switch(unit) {
		// 			case PowerUnit.passportKeys.self:
		// 				return PowerUnit.settingNames[settingId]
		// 			case ServiceUnit.passportKeys.self:
		// 				return ServiceUnit.settingNames[settingId]
		// 			case ModemUnit.passportKeys.self:
		// 				return ModemUnit.settingNames[settingId]
		// 			case ElectricMeter.passportKeys.self:
		// 				return ElectricMeter.settingNames[settingId]
		// 			case Breaker.passportKeys.self:
		// 				return Breaker.settingNames[settingId]
		// 			default:
		// 				return Station.settingNames[settingId]
		// 		}
		// 	} else if (Station.settingNames[unit]) {
		// 		switch(unit) {
		// 			case Station.passportKeys.measurePotentialOnOffStation.self:
		// 				return Station.settingNames[Station.passportKeys.measurePotentialOnOffStation.self][settingId]
		// 			default:
		// 				return Station.settingNames[unit]
		// 		}
		// 	} else {
		// 		return settingId
		// 	}
		// },

		parseSettingValue(id, value, unit) {
			let unitObj = Station
			
			switch(unit) {
				case Station.passportKeys.modemUnit.self:
					unitObj = ModemUnit
					break
				case Station.passportKeys.electricMeter.self:
					unitObj = ElectricMeter
					break
				case Station.passportKeys.serviceUnit.self:
					unitObj = ServiceUnit
					break
				case Station.passportKeys.powerUnit.self:
					unitObj = PowerUnit
					break
				case Station.passportKeys.breaker.self:
					unitObj = Breaker
					break
			}

			if (value === true || value === false) {
				return [
					unitObj.settingNames[id] ?? id,
					Station.flagText(value),
				]
			}

			switch (id) {
				case Station.passportKeys.installationDate:
				case Station.passportKeys.overhaulDate:
				case Station.passportKeys.produceDate:
				case ElectricMeter.passportKeys.verificationDate:
				case PowerUnit.passportKeys.operaionAndProtectionStartDate:
					// console.log('value = ', value.type == 'date')
					return [
						unitObj.settingNames[id],
						value ? chartDateStr(parseApiTimeDate(value)) : '-',
					]
				case ElectricMeter.passportKeys.surveyStartTime:
					return [
						unitObj.settingNames[id],
						dateTimeToTimeString(parseApiTimeDate(value)),
					]
				case unitObj.passportKeys.unitVersion:
					return [
						unitObj.settingNames[id],
						unitObj.versionNames[value],
					]
				case Station.passportKeys.measurePotentialOnOffStation.self:
					return [
						unitObj.settingNames[id].self,
						`${value.is_enable ? 'Так, ' + value.period : 'Ні'}`,
					]
				case Station.passportKeys.surveyPeriod:
					return [
						unitObj.settingNames[id],
						value ? value + (value ? ' c' : '') : '-'
					]
				// case Station.passportKeys.notificationDistributionLists.self:
				// 	return [
				// 		unitObj.settingNames[id].self,
				// 		value
				// 	]
				case Station.passportKeys.protectionMethod:
					return [
						Station.settingNames[id],
						Station.protectionMethods[value]?.title,
					]
				case Station.passportKeys.stationType:
					return [
						Station.settingNames[id],
						Station.types[value]?.title,
					]
				case Station.passportKeys.location:
					return [
						Station.settingNames[id],
						`${value?.coordinates[0]} ${value?.coordinates[0]}`,
					]
				case Station.passportKeys.relatedStations:
					return [
						Station.settingNames[id],
						this.stationsStore.stationsArray
							.filter((station) => value.includes(station.id))
							.map((station) => `"${station.shortName ? station.shortName : station.name}"`)
							.join(',\xa0\xa0\xa0\xa0 '),
					]
				case Station.passportKeys.potentialSource:
					return [
						Station.settingNames[id],
						Station.potentialSourceNames[value],
					]
				case Station.passportKeys.departmentId:
					return [
						Station.settingNames[id],
						value?.title ?? DEPARTMENT_TITLE ,
					]
				case Station.passportKeys.sectorId:
					return [
						Station.settingNames[id],
						value?.title ?? SECTOR_TITLE,
					]
				case Station.passportKeys.pipelineId:
					return [
						Station.settingNames[id],
						this.pipelines
							.filter((el) => value.includes(el.id))
							.map((el) => el.title),
					]
				case ElectricMeter.passportKeys.type:
					return [
						ElectricMeter.settingNames[id],
						ElectricMeter.versionNames[value],
					]
				case ModemUnit.passportKeys.allowedGridMode1:
				case ModemUnit.passportKeys.allowedGridMode2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.allowedGridModeNames[value]?.title,
					]
				case ModemUnit.passportKeys.allowedServers1:
				case ModemUnit.passportKeys.allowedServers2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.serverNames[value]?.title,
					]
				case ModemUnit.passportKeys.speed1:
				case ModemUnit.passportKeys.speed2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.portSpeedModeNames[value]?.title,
					]
				case ModemUnit.passportKeys.bitCount1:
				case ModemUnit.passportKeys.bitCount2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.dataBitsCountNames[value]?.title,
					]
				case ModemUnit.passportKeys.stopBit1:
				case ModemUnit.passportKeys.stopBit2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.stopBitsCountNames[value]?.title,
					]
				case ModemUnit.passportKeys.parity1:
				case ModemUnit.passportKeys.parity2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.parityNames[value]?.title,
					]
				case ModemUnit.passportKeys.convertingRtu1:
				case ModemUnit.passportKeys.convertingRtu2:
					return [
						ModemUnit.settingNames[id],
						ModemUnit.rtuModeNames[value]?.title,
					]
				case ServiceUnit.passportKeys.securityCircuit_1_purpose:
				case ServiceUnit.passportKeys.securityCircuit_2_purpose:
				case ServiceUnit.passportKeys.securityCircuit_3_purpose:
				case ServiceUnit.passportKeys.securityCircuit_4_purpose:
				case ServiceUnit.passportKeys.securityCircuit_5_purpose:
				case ServiceUnit.passportKeys.securityCircuit_6_purpose:
					return [
						ServiceUnit.settingNames[id],
						ServiceUnit.securityCircuitPurposeNames[value],
					]
				default:
					return [
						unitObj.settingNames[id] ?? id,
						value,
					]
			}
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		pipelines() {
			const passport = Object.fromEntries(
				this.stationsStore.station(this.stationId).passport
			)

			return passport[Station.passportKeys.org]['pipelines']
		},

		tableItems() {
			const items = []
			const passport = Object.fromEntries(
				this.stationsStore.station(this.stationId).passport
			)

			// console.log('passport', Object.fromEntries(this.stationsStore.station(this.stationId).passport))
			// Normalize
			for (const field of Object.values(FIELD_NAMES)) {
				delete passport[field]
			}
			delete passport[Station.passportKeys.updateBy]
			delete passport[Station.passportKeys.creatorId]
			delete passport[Station.passportKeys.stabilization.self]
			delete passport[Station.passportKeys.metricsId]
			delete passport['survey_start_time']
			passport[Station.passportKeys.orgId] = passport['org_name']
			delete passport['org_name']
			delete passport['org']
			delete passport['_items']
			delete passport[Station.passportKeys.notificationDistributionLists.self]
			passport[Station.passportKeys.departmentId] = passport[Station.passportKeys.department]
			delete passport[Station.passportKeys.department]
			passport[Station.passportKeys.sectorId] = passport[Station.passportKeys.sector]
			delete passport[Station.passportKeys.sector]

			// Enumerate all units
			for (const [unitId, unitName] of Object.entries(Station.unitNames)) {
				if (!passport[unitId]) {
					continue
				}

				// console.log('unit', unitId, unitName)
				delete passport[unitId]['related_rpc']

				// Enumerate all unit items
				for (const [itemId, itemValue] of Object.entries(passport[unitId])) {
					// console.log('unit item', itemId, itemValue)
					const [name, value] = this.parseSettingValue(itemId, itemValue, unitId)
					items.push({
						name: name,
						unit: unitName,
						value: value,
					})
				}

				delete passport[unitId]
			}

			// console.log('passport', passport)
			// Enumerate all not unit items
			for (const [itemId, itemValue] of Object.entries(passport)) {
				const [name, value] = this.parseSettingValue(itemId, itemValue, 'station')
				items.push({
					name: name,
					unit: '',
					value: value
				})
			}

			return items
		},
	},
}
</script>




<style src="@/assets/table.css" scoped />
<style scoped>

</style>